export function isElement(a: any): a is Element {
  return a instanceof Element;
}
